const statusTypes: StatusTypeArray = [
  { id: 'working', title: "working" },
  { id: 'taking_break', title: "taking_break" },
  { id: 'out_of_office', title: "out_of_office" },
];

export { statusTypes as default };
